// JavaScript 객체가 의도치 않게 String 변환되어 들어온 흔적을 차단하기 위한 패턴.
// '[object Object]', '[object Window]', '[object HTMLAnchorElement]' 등을 모두 거른다.
const OBJECT_TO_STRING_RE = /^\[object [A-Za-z]+\]$/;

export function isValidNaverKey(value: unknown): value is string {
  if (typeof value !== 'string') {
    return false;
  }
  const trimmed = value.trim();
  if (trimmed.length === 0) {
    return false;
  }
  if (OBJECT_TO_STRING_RE.test(trimmed)) {
    return false;
  }
  return true;
}
